import React from "react";
import { Link } from "react-router-dom";
import { Users, Luggage, Check, ArrowRight } from "lucide-react";
import { PageHero } from "../components/site/Common";
import { FLEET, IMG, vehicleAlt } from "../mock";
import { SeoExtras } from "../components/site/SeoExtras";
import { useReveal } from "../lib/lang";

const Fleet = () => {
  useReveal();
  return (
    <div data-testid="fleet-page">
      <PageHero image={IMG.fleet} eyebrow="The fleet" title="Comfort for every journey"
        sub="From solo travellers to large families, our modern, immaculately maintained vehicles are chosen for comfort, space and style." />
      <section className="py-12 sm:py-24">
        <div className="max-w-7xl mx-auto px-6 space-y-5 sm:space-y-8">
          {FLEET.map((v, i) => (
            <div key={v.id} className="reveal lift bg-white rounded-[24px] border border-[#183C35]/10 overflow-hidden grid md:grid-cols-2" data-testid="fleet-card">
              <div className={`bg-[#F1ECE0] h-48 sm:h-72 md:h-auto overflow-hidden group ${i % 2 ? "md:order-2" : ""}`}>
                <img src={v.image} loading="lazy" alt={vehicleAlt(v)} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </div>
              <div className="p-5 sm:p-8 lg:p-12">
                <p className="text-[14px] text-[#202522]/60">{v.model}</p>
                <h2 className="font-serif-d text-[26px] sm:text-[36px] font-semibold text-[#183C35] mt-1">{v.name}</h2>
                <div className="flex flex-wrap gap-5 mt-4 text-[15px]">
                  <span className="flex items-center gap-2"><Users className="w-4 h-4 text-[#3E7F8E]" />{v.paxText}</span>
                  <span className="flex items-center gap-2"><Luggage className="w-4 h-4 text-[#3E7F8E]" />{v.bagsText}</span>
                </div>
                <ul className="mt-4 sm:mt-6 grid sm:grid-cols-2 gap-2 sm:gap-3">
                  {v.features.map((f) => <li key={f} className="flex gap-2.5 text-[15px]"><Check className="w-4 h-4 mt-0.5 text-[#3E7F8E]" />{f}</li>)}
                </ul>
                <div className="mt-5 sm:mt-8 pt-4 sm:pt-6 border-t border-[#183C35]/10 flex items-end justify-between gap-4">
                  <div>
                    <p className="text-[13px] text-[#202522]/60">from</p>
                    <p className="font-serif-d text-[28px] sm:text-[34px] text-[#183C35] leading-none">€{v.from}</p>
                  </div>
                  <Link to={`/book?vehicle=${v.id}`} data-testid={`book-class-${v.id}`} className="inline-flex items-center gap-2 rounded-full bg-[#183C35] text-[#F7F3EA] px-5 sm:px-6 py-2.5 sm:py-3 text-[14.5px] sm:text-[16px] font-medium hover:bg-[#21524A] transition-colors duration-200">
                    Book this class <ArrowRight className="w-4 h-4" />
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
      <SeoExtras path="/fleet" page="fleet" />
    </div>
  );
};

export default Fleet;
